import o from"./index.module.scss.js";const s=o;export{s as PanelTheme};
//# sourceMappingURL=index.js.map
